import React from 'react';
function Footer() {

    return (
        <div className="footer pattern">
             <div style={{alignContent:"center",alignItems:"center",display:"flex"}}>
            <p className="m footer-text-web"><strong>Enero Comunicación · </strong>info@agenciaenero.com</p>
            <p  className="m footer-text-mobile"><strong>Enero Comunicación</strong> · info@agenciaenero.com</p>
           
            </div>
        </div>

    )
}

export default Footer;